module.exports = {"pagination":{"ListChangeSets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ChangeSetSummaryList"},"ListEntities":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"EntitySummaryList"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/marketplace-catalog-2018-09-17.paginators.json
// module id = 678
// module chunks = 2